module.exports = __webpack_public_path__ + "static/media/tame.2adf64e4.png";